import { NavLink } from 'react-router-dom';

import {
  IconChevronDown as ChevronDownSVG,
  IconChevronUp as ChevronUpSVG,
  IconGeneralComponents as GeneralComponentsSVG,
} from '../../../core';
import { Menus, NavigationTab } from '../types';

import CompactTab from './CompactTab';

const GeneralComponents = ({
  handleMenuCollapse,
  collapsedMenus,
  isMenuClosed,
  setIsMenuClosed,
}: Omit<NavigationTab, 'collapsedSubMenus'>) => {
  const link = '/general-components';

  if (isMenuClosed)
    return (
      <CompactTab
        menuOption={Menus.GENERAL_COMPONENTS}
        icon={<GeneralComponentsSVG />}
        handleMenuCollapse={handleMenuCollapse}
        setIsMenuClosed={setIsMenuClosed}
        href={link}
      />
    );

  return (
    <li>
      <NavLink
        to={link}
        className={({ isActive }) => (isActive ? 'active' : '')}
        onClick={() => handleMenuCollapse(Menus.GENERAL_COMPONENTS)}
      >
        <>
          <div>
            <GeneralComponentsSVG />
            <span>General Components</span>
          </div>
          {collapsedMenus.includes(Menus.GENERAL_COMPONENTS) ? (
            <ChevronDownSVG />
          ) : (
            <ChevronUpSVG />
          )}
        </>
      </NavLink>
      <ul
        className={`lvl-2 ${collapsedMenus.includes(Menus.GENERAL_COMPONENTS) ? 'collapsed' : ''}`}
      >
        <li>
          <NavLink
            to="/general-components/buttons"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Buttons</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/links"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Links</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/form-elements"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Form Elements</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/communication"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Communication</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/navigation"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Navigation</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/selection"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Selection</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/containment"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Containment</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/general-components/table"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Table</span>
          </NavLink>
        </li>
      </ul>
    </li>
  );
};

export default GeneralComponents;
